/**
 * Hook to fetch activity details from the backend.
 */
import { useQuery } from "@tanstack/react-query";
import { getActivityById } from "../../api/activities";

const useActivityDetails = (activityId: number) => {
  const { data, isLoading } = useQuery({
    queryKey: ["activity", activityId],
    queryFn: () => getActivityById(activityId),
    enabled: !!activityId,
  });

  return { activity: data?.data, isLoading };
};

export default useActivityDetails;
